var congress_ta_filter = (function( $ ) {

	var _init = function() {
		congress_therapeutic_area_filter_dropdown()
	};

	function congress_therapeutic_area_filter_dropdown() {
		$congress_ta_filter = $( '#congress-ta-filter-wrapper' );

		if ( $congress_ta_filter.length > 0 ) {
			$select = $( '.ta-filter-select2' ).select2( {
				placeholder:             'Select Therapeutic Area',
				minimumResultsForSearch: Infinity,
				dropdownParent:          $congress_ta_filter
			} );

			$select.data( 'select2' ).$dropdown.addClass( 'ta-filter-dropdown' );
			$select.data( 'select2' ).$container.addClass( 'ta-filter-select-wrapper' );
		}
	}

	$( document ).ready( _init );

	return {};

})( jQuery );